import React from 'react'
import { PeopleSurveyedCard } from '@diversioteam/diversio-ds'

import { withErrorBoundary } from 'config/withErrorBoundary/withErrorBoundary'
import { usePeopleSurveyedByRole } from 'hooks/usePeopleSurveyedByRole'

const PeopleSurveyedWithoutEB = () => {
    const { data, isLoading } = usePeopleSurveyedByRole()

    if (isLoading || !data) {
        return null
    }

    return (
        <div className="ddsi-card">
            <PeopleSurveyedCard {...data} />
        </div>
    )
}

export const PeopleSurveyed = withErrorBoundary(PeopleSurveyedWithoutEB, {})
